import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as AntIcons from "@ant-design/icons";
import * as FAIcons from "@fortawesome/free-solid-svg-icons";

const antIconMap = AntIcons;

export default function DynamicIcon({ component, type = "ant", size = 40 }) {
  if (type === "ant") {
    const IconComponent = antIconMap[component];
    if (!IconComponent) {
      console.warn("Ant icon not found:", component);
      return null;
    }

    return <IconComponent style={{ fontSize: size }} />;
  }

  const faIcon = FAIcons[component];
  if (!faIcon) {
    console.warn("FA icon not found:", component);
    return null;
  }

  return <FontAwesomeIcon icon={faIcon} style={{ fontSize: size }} />;
}

DynamicIcon.propTypes = {
  component: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["ant", "fa"]),
  size: PropTypes.number,
};
